import BN from "bignumber.js"

export const tool = {
  methods: {
    // 纯数字
    onlyNumber (val, n) {
      let rg
      if (n === 0) {
        rg = new RegExp(/[0-9]+/, 'g')
      } else {
        const rgString = '[0-9]+\\.?([0-9]{0,' + n + '})?'
        rg = new RegExp(rgString, 'g')
      }
      let myVal = val
      let rgResult = myVal.match(rg)
      // 如果未找到皮配值
      if (!rgResult) {
        myVal = ''
      } else {
        myVal = rgResult[0]
      }
      // 去掉数字前面的0
      // myVal = myVal.replace(/^0+([1-9][0-9]*(?:\.|\.[0-9]+)?)$/, '$1')
      return myVal
    },
    // 小于某数
    smallTo (val, number) {
      if (new BN(val).gt(new BN(number))) {
        return number
      }
      return val
    },
    // 大于某数
    bigTo (val, number) {
      if (new BN(number).gt(new BN(val))) {
        return number
      }
      return val
    },
    // 清除千分号
    clearThousandSeparator (val) {
      return val.toString().replace(/,/g, '')
    },
    // 增加千分号
    addThousandSeparator (val) {
      return val.toString().replace(/\d+/, function(s){
        return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
      })
    }
  }
}
